"use strict";
/**
 * Licensed Materials - Property of IBM
 * IBM Business Analytics (C) Copyright IBM Corp. 2020
 * US Government Users Restricted Rights - Use, duplication or disclosure restricted by GSA ADP Schedule Contract with IBM Corp.
 */

var __importDefault = void 0 && (void 0).__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};

Object.defineProperty(exports, "__esModule", {
  value: true
});

var mobx_state_tree_1 = require("mobx-state-tree");

var MeasureDataItem_1 = __importDefault(require("../../definitions/properties/MeasureDataItem"));

var MAIN_PANEL = 'mainPanel';
var CHILD_COND_FORMAT_PANEL = 'childCFPanel';
var CHILD_CHANGE_PALETTE_PANEL = 'childPalettePanel';
var UIPanelModelFactory = mobx_state_tree_1.types.model('UIPanelModel', {
  hasTargetValue: mobx_state_tree_1.types.optional(mobx_state_tree_1.types.boolean, false)
}).volatile(function () {
  return {
    measureDataItem: null,
    panelId: MAIN_PANEL,
    previousPanelId: MAIN_PANEL,
    measures: [],
    uiContext: null,
    getMSTConditionalFormatModelFn: null
  };
}).views(function (self) {
  return {
    getMeasureDataItem: function getMeasureDataItem() {
      return self.measureDataItem;
    },
    getDataItemId: function getDataItemId() {
      return self.measureDataItem ? self.measureDataItem.getDataItemId() : null;
    },
    getDataItemLabel: function getDataItemLabel() {
      return self.measureDataItem ? self.measureDataItem.getLabel() : null;
    },
    getMSTConditionalFormatModel: function getMSTConditionalFormatModel() {
      var measure;

      if (self.uiContext.isKpiVis()) {
        measure = self.measureDataItem ? self.measureDataItem : MeasureDataItem_1.default.getPlaceHolderMeasureDataItem();
      } else {
        measure = self.measureDataItem;
      }

      return measure ? self.getMSTConditionalFormatModelFn(measure.getDataItemId()) : null;
    },
    getPanelId: function getPanelId() {
      return self.panelId;
    },
    getMeasures: function getMeasures() {
      return self.measures;
    }
  };
}).views(function (self) {
  return {
    get isDisabled() {
      if (!self.measureDataItem) {
        return true;
      } // Always enable for Xtab and Table so return false


      if (!self.uiContext.isKpiVis()) {
        return false;
      }

      var conditionalFormatModel = self.getMSTConditionalFormatModelFn(self.measureDataItem.getDataItemId()); // If has colorBy or has min max then return false to enable

      if (conditionalFormatModel.hasColorBy || self.hasTargetValue) {
        return false;
      } // return true to disable


      return true;
    },

    get isChildCFPanel() {
      return self.panelId === CHILD_COND_FORMAT_PANEL;
    }

  };
}).actions(function (self) {
  return {
    _updateDisplayPanel: function _updateDisplayPanel() {
      if (self.previousPanelId !== MAIN_PANEL) {
        if (self.uiContext.isKpiVis()) {
          self.previousPanelId = MAIN_PANEL;
        } else if (!self.uiContext.hasDisplayedChildPanel()) {
          // Case:
          // create a Table with Product line and Revenue
          // open CF Panel for Revenue
          // while panel is open
          // DnD to replace Revenu with Unit Cost
          // Notice the Top Banner with Unit Cost
          // Click on the Back button in Top Banner to close down the child panel
          // ==> Result the main Properties Panel should display correctly
          self.uiContext.displayChildPanelForMeasure(self.measureDataItem);
        }
      }
    }
  };
}).actions(function (self) {
  return {
    afterCreate: function afterCreate() {
      var env = mobx_state_tree_1.getEnv(self);
      var measures = env.measures,
          getMSTConditionalFormatModelFn = env.getMSTConditionalFormatModelFn;
      self.measures = measures;
      self.getMSTConditionalFormatModelFn = getMSTConditionalFormatModelFn;
    },
    setMeasureDataItem: function setMeasureDataItem(value) {
      self.measureDataItem = value;
    },
    setPanelId: function setPanelId(value) {
      self.panelId = value;
    },
    setHasTargetValue: function setHasTargetValue(value) {
      self.hasTargetValue = value;
    },
    resetPanelId: function resetPanelId() {
      if (self.uiContext.isKpiVis()) {
        self.panelId = MAIN_PANEL;
      } else if (self.panelId === CHILD_CHANGE_PALETTE_PANEL) {
        self.panelId = CHILD_COND_FORMAT_PANEL;
      } else {
        self.panelId = MAIN_PANEL;
      }
    },
    setMeasures: function setMeasures(measures) {
      if (measures === void 0) {
        measures = [];
      }

      var previousMeasures = self.measures;
      self.measures = measures; // The following code here is added to support undo/redo
      // The UI contents and panels must match that of the current state of slot mappings

      if (self.measureDataItem) {
        if (self.isDisabled) {
          // This is the KPI case
          // An undo/redo action of KPI that delete the target slot mapping so get here
          self.uiContext.closeAllChildPanel();
        } else {
          var foundMeasure = self.measures.find(function (measure) {
            return measure.getDataItemId() === self.measureDataItem.getDataItemId();
          });

          if (foundMeasure) {
            // through undo/redo the measure got added back to the slot mapping so
            // in this case launch the correct panel for that measure
            // Measure is still mapped im data slots so call _updateDisplayPanel to update the panel
            self._updateDisplayPanel();
          } else {
            // The measure got removed from slot mapping
            // The measureDataIemt is no longer in the slot mapping, most likely got deleted by undo/redo
            self.previousPanelId = self.panelId; // The measure has been removed from data slots mapping
            // If both old and new slot mapping lists have idential number of items but not
            // the same contents then the item was replaced in build-up or in slot editor
            // In this case replace the old one with the new one that it was replaced with

            var potentialReplacedDataItem = previousMeasures.length > 0 && previousMeasures.length === self.measures.length;

            if (potentialReplacedDataItem) {
              // Is it a replacement of another data item using buid-up?
              // Loop through the array and find the replacement measure
              // For R7 exit when first one found not matched
              var foundMeasure_1;

              var _loop_1 = function _loop_1(count) {
                var matchedAtIdx = -1;
                previousMeasures.find(function (measure, idx) {
                  if (measure.getDataItemId() === self.measures[count].getDataItemId()) {
                    matchedAtIdx = idx;
                  }
                });

                if (matchedAtIdx !== -1) {
                  // Remove the found item from previous measure list so that it does get include in the
                  // next round of search
                  previousMeasures.splice(matchedAtIdx, 1);
                } else {
                  foundMeasure_1 = self.measures[count];
                }
              };

              for (var count = 0; count < self.measures.length && !foundMeasure_1; count++) {
                _loop_1(count);
              }

              self.measureDataItem = foundMeasure_1;
            } else {
              self.uiContext.closeAllChildPanel();
            }
          }
        }
      }
    },
    setUIContext: function setUIContext(uiContext) {
      self.uiContext = uiContext;
    }
  };
});
exports.default = UIPanelModelFactory;
